<template>
  <div v-if="!isButtom" :class="`comp-xl-association`">
    <jw-select :show-extra-options="false" @input-value-change="changeKeyword" :filter-option="false" :trigger-props="{ autoFitPopupMinWidth: true }" @popup-visible-change="popupSelect" :loading="loading" v-model="selectVal" :disabled="disabled" :options="list" allow-search :placeholder="`${$t('请选择数据')}`" :max-tag-count="1" @change="changeHandle" allow-clear @clear="clearHandle" @dropdown-reach-bottom="dropdownSelect">
      <template #option="{ data }">
        <div class="field">
          <div :class="`matrix-association-main-field ${columns?.length > 1 ? 'matrix-association-main-bottom' : ''}`">{{ data[mainField] }}</div>
        </div>
      </template>
    </jw-select>
    <jw-button :disabled="disabled" @click="openDialog">
      <template #icon>
        <icon-plus />
      </template>
    </jw-button>
  </div>
  <div v-if="isButtom" :class="`comp-xl-association`">
    <jw-button type="outline" :loading="loading" :disabled="disabled" @click="openDialog" size="small">
      <!-- <template #icon>
        <icon-plus />
      </template> -->
      <template #default>选择已有数据</template>
    </jw-button>
  </div>
  <!-- 弹窗打开 S -->
  <jw-modal v-model:visible="visible" width="70%" title-align="start" :on-before-ok="handleOk" unmount-on-close :mask-closable="false" class="xl-entity-data-list-modal">
    <template #title> {{ $t('选择关联') }}{{ objectName || $t('对象') }} </template>
    <jw-space direction="vertical" fill>
      <div style="display: flex; justify-content: space-between">
        <jw-trigger popup-container=".xl-entity-data-list-modal" class="trigger-container" v-model:popup-visible="filterVisible" trigger="click" position="bl">
          <jw-button @click="toggleVisible" type="outline"><icon-filter />{{ filterText }}</jw-button>
          <template #content>
            <div class="custom-field-condition-public">
              <!-- <custom-field-condition ref="customRefs" popup=".trigger-container" :title="$t('触发审批条件')" @cb="getConditions" :show-colon="false" label-col-flex="140px" :filter="false" :entity="data.entity" :children="filterConditions?.children" fromPage="associated"></custom-field-condition> -->

              <fh-custom-search-ultra ref="customFieldConditionRef" :border="true" :entity="data.entity" :conditions="filterConditions?.children" :showDefaultCondition="true" @cb="getConditions" :width="600" :maxHeight="300" @clearAll="clearAllCondition" @submit="searchSubmit" :headerTitle="$t('条件配置')"> </fh-custom-search-ultra>
            </div>
          </template>
        </jw-trigger>
        <jw-button type="text" v-if="userInfo?.roles?.indexOf(roleName) !== -1" @click="openLyForm">
          {{ buttonText?.[roleName] || $t('新建') }}
        </jw-button>
      </div>
      <fh-table v-model:selected-row-keys="ids" v-on="tPropsEvent" v-bind="tProps" ref="xlUserTable" :scroll="{ y: 400 }" :columns="formatPopColumns" @select-change="xlTableSelect"> </fh-table>
    </jw-space>
  </jw-modal>
  <!-- 弹窗打开 E -->
  <fh-add-edit ref="addEditRef" @cb="loadTList()" />
</template>

<script setup lang="jsx">
import { ref, h, reactive, onMounted, nextTick, resolveDynamicComponent, computed } from 'vue';
import { Message } from '@arco-design/web-vue';
import { setService, layoutService } from '@/api/';
import { tools } from '@/utils/tools';
import useFhTable from '@/hooks/fh-table';
import { watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import { useUserStore } from '@/store';
const { userInfo } = useUserStore();
const data = reactive({
  entity: ''
});
const filterConditions = ref({ value: null });
const customFieldConditionRef = ref();
const props = defineProps({
  type: {
    type: [String, Number],
    default: ''
  },
  id: {
    type: [String, Number],
    default: ''
  },
  entity: {
    type: [String, Number],
    default: ''
  },
  multiple: {
    type: Boolean,
    default: false
  },
  isButtom: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean
  },
  modelValue: {
    type: [String, Number, Array]
  },
  selectedItem: {
    type: [Object, Array]
  },
  taskItem: {
    type: [Object, Array]
  },
  placeholder: {
    type: String,
    default: ''
  }
});
const emits = defineEmits(['update:modelValue', 'update:selectedItem', 'change']);

const isButtom = computed(() => props.isButtom);
const mainField = ref('name');
const isNeedRequest = ref(true);
const totalPage = ref(0);
const page = ref(1);

const popupSelect = async (visible) => {
  if (visible && isNeedRequest.value) {
    page.value = 1;
    await getAssociationRadioFields();
    await getEntityList();
  }
};

const list = ref([]);
const columns = ref([]);
const popColumns = ref([]);
const formatPopColumns = ref([]);
const loading = ref(false);
const keyword = ref(null);
const timer = ref(null);

const changeKeyword = (v) => {
  if (keyword.value != v) {
    keyword.value = v;
    if (timer.value !== null) {
      clearInterval(timer.value);
    }
    timer.value = setTimeout(() => {
      page.value = 1;
      getEntityList(false);
    }, 500);
  }
};

const getAssociationRadioFields = async (isPop = false) => {
  try {
    loading.value = true;
    const res = await setService.getEntitySettings({ entity: data?.entity, apiIndex: Math.random() }); //查询entity所有字段
    if (!res.error) {
      if (isPop) {
        popColumns.value = res.result;
      } else {
        columns.value = res.result;
      }
      mainField.value = res.result.filter((v) => v?.mainField)?.[0]?.fieldKey;
    }
    loading.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};
const apiSwitch = ref(false);
const dropdownSelect = () => {
  if (!apiSwitch.value && totalPage.value > page.value) {
    page.value++;
    nextTick(() => {
      getEntityList();
    });
  }
};
const getEntityList = async () => {
  isNeedRequest.value = false;
  loading.value = true;
  apiSwitch.value = true;
  try {
    const params = {
      scope: '0',
      entity: data?.entity,
      page: data.page,
      pageSize: data.pageSize,
      keyWord: keyword.value || ''
    };
    setLoadListParams(params);
    const res = await loadTList(1);
    if (!res.error) {
      const _data = res.result.records;
      _data.map((v) => {
        v['value'] = v?.id;
        v['label'] = v?.[mainField.value];
      });
      totalPage.value = res.result?.pages;
      if (page.value == 1) {
        list.value = _data;
      } else {
        list.value = [...list.value].concat(_data);
      }
    }
    loading.value = false;
    apiSwitch.value = false;
  } catch (e) {
    apiSwitch.value = false;
    console.log(e);
  }
};
const selectOption = ref(null);

const selectVal = ref(props.multiple ? [] : '');

// select事件
const changeHandle = (v) => {
  keyword.value = '';
  emits('update:modelValue', props.multiple ? v?.filter((v) => v !== '') : v);
  const _list = [];
  if (props.multiple && selectVal.value?.length > 0) {
    const _tmp = [];
    list.value.map((v) => {
      _tmp.push(v?.value);
    });
  }
  let item = [...list.value, ..._list].filter((el) => (props.multiple ? v.indexOf(el.value) > -1 : v === el.value));
  item = item.map((el) => {
    el[`_name`] = el.label;
    return el;
  });

  emits('change', v, item);
  emits('update:selectedItem', props.multiple ? item : item?.[0]);
};

// 弹窗
const visible = ref(false);
const tableLoading = ref(false);
// 表格的render抽离
const setRender = (params) => {
  const fieldValue = params.fieldValue;
  if (fieldValue || fieldValue === 0) {
    if (params.fieldType === 9) {
      const hasRangeValue = tools.isJSON(fieldValue) && JSON.parse(fieldValue)?.beginDate && JSON.parse(fieldValue)?.endDate;
      if (hasRangeValue) {
        return Object.values(JSON.parse(fieldValue))?.join('/');
      } else {
        return '-';
      }
    } else if (params.fieldType === 6) {
      const Cpm = resolveDynamicComponent('ly-avatar');
      return h(Cpm, {
        record: fieldValue
      });
    } else if (params.fieldType === 7) {
      const fieldExt = JSON.parse(params.fieldExt);
      return !isNaN(parseFloat(fieldValue)) ? parseFloat(fieldValue).toFixed(fieldExt?.numberFormat != 100 ? fieldExt?.numberFormat : 3) + (fieldExt?.numberUnit ? fieldExt.numberUnit : '') : '-';
    } else if (params.fieldType === 11) {
      return h(
        'a',
        {
          style: {
            color: '#165dff',
            cursor: 'pointer'
          },
          href: fieldValue,
          target: '_blank'
        },
        t('查看')
      );
    } else if (params.fieldType === 12) {
      return fieldValue?.label ?? fieldValue ?? '-';
    } else if (params.fieldType === 16) {
      return (fieldValue && tools.getPriceShow(fieldValue, params.fieldExt)) || '-';
    } else if (params.fieldType === 18) {
      const cpm = resolveDynamicComponent('ly-attachment-list');
      return h(cpm, {
        fieldValue: fieldValue
      });
    } else if (params.fieldType === 22) {
      //部门
      return (
        (fieldValue &&
          fieldValue
            ?.map((i) => {
              return i.name;
            })
            .join(',')) ||
        '-'
      );
    } else if (params.fieldType === 23) {
      return tools.getPercentage(fieldValue).toFixed(JSON.parse(params.fieldExt)?.numberFormat) + '%' || '-';
    } else if (params.fieldType === 24) {
      //计算类型
      if (params?.fieldExt && typeof JSON.parse(params?.fieldExt) == 'object') {
        if (JSON.parse(params?.fieldExt).type == 6 || JSON.parse(params?.fieldExt).type == 16) {
          //金额类型
          return (fieldValue && tools.getPriceShow(fieldValue, 2)) || '-';
        } else if (JSON.parse(params?.fieldExt).type == 5 || JSON.parse(params?.fieldExt).type == 7) {
          //金额类型
          return !isNaN(parseFloat(fieldValue)) ? parseFloat(fieldValue).toFixed(JSON.parse(params?.fieldExt)?.dataType || 2) : '-';
        } else if (JSON.parse(params?.fieldExt).type == 23) {
          //金额类型
          return ((fieldValue && tools.getPercentage(fieldValue).toFixed(JSON.parse(params?.fieldExt)?.dataType || 2)) || '-') + '%';
        } else {
          return fieldValue ?? '-';
        }
      } else {
        return fieldValue ?? '-';
      }
    } else if (params.fieldType === 25) {
      return fieldValue?.[0]?.label ? fieldValue?.map((v) => v?.label)?.join(',') : '-';
    } else if (params.fieldType === 4 && params.fieldKey === 'taxRate') {
      return tools.getPercentage(fieldValue, 0) + '%' || '-';
    } else if (params.fieldType === 4 && params.fieldKey === 'status') {
      //生命状态
      const Cpm = resolveDynamicComponent('xl-status');
      return h(Cpm, {
        status: fieldValue,
        statusOrigin: params.record['statusOrigin']
      });
    } else {
      return fieldValue?.label ?? fieldValue?.value ?? fieldValue ?? '-';
    }
  } else {
    return '-';
  }
};
// 创建列配置
const createColumnConfig = (item) => {
  if (item.fieldType == 21) {
    //引用字段
    item.fieldType = item?.business?.fieldType;
    item.fieldExt = item?.business?.fieldExt;
  }
  const colType = {
    title: item.fieldName,
    colKey: item.fieldKey,
    ellipsis: true,
    tooltip: true,
    id: item.id,
    width: item.fieldName.length <= 5 ? 120 : item.fieldName.length * 30,
    fixed: item?.businessData == 1 ? 'left' : undefined,
    className: item.fieldType == 27 ? 'sub-form-table-border' : ''
  };
  // 表格的cell函数
  const render = (h, { row }) => {
    const params = {
      ...item,
      fieldValue: row[item.fieldKey],
      fieldType: item.fieldType,
      fieldExt: item.fieldExt,
      record: row
    };
    return setRender(params);
  };
  if (item.type === 1) {
    colType.colType = t(t('基础字段'));
  }
  if ([8, 9, 12].includes(item.fieldType) || (item.fieldType === 21 && item?.business?.fieldType === 18)) {
    colType.width = 200;
  }

  console.log('创建列配置', colType);

  colType.cell = render;
  return colType;
};
// 创建子表单列配置
const createChildColumns = (item) => {
  const colTypeChildren = [];
  item?.settings?.forEach((el, index) => {
    const childRender = (h, { row }) => {
      //   const record = JSON.parse(JSON.stringify(row));
      const subFormData = row?.[item?.fieldKey] || [];
      // 遍历子表单数据，为每个子表单记录渲染单元格
      return h(
        'p',
        { class: 'child-table-container' },
        subFormData?.length > 0
          ? [
              ...subFormData.map((subFormRecord) => {
                const params = {
                  ...el,
                  fieldValue: subFormRecord?.[el.fieldKey] || '', // 使用子表单中的数据
                  record: subFormRecord // 使用子表单中的数据
                };
                return h('p', { class: 'child-table-container-second' }, setRender(params));
              })
            ]
          : '-'
      );
    };
    const getColType = {
      title: el.fieldName,
      colKey: el.fieldKey,
      ellipsis: true,
      tooltip: true,
      id: el.id,
      width: el.fieldName.length <= 5 ? 120 : el.fieldName.length * 30,
      cell: childRender,
      cellClass: index == 0 ? 'sub-form-table-border-left' : index == item?.modules?.length - 1 ? 'sub-form-table-border-right' : ''
    };
    colTypeChildren.push(getColType);
  });
  return colTypeChildren;
};

// 表格表头数据字段
const getColumns = (fields) => {
  const fieldList = fields?.filter((i) => ['parentCustomerId', 'calendarId', 'callId', 'recordId'].indexOf(i.fieldKey) === -1);
  const list = [];
  fieldList?.forEach((item) => {
    const colConfig = createColumnConfig(item);
    if (item?.fieldType == 27) {
      //子表单
      const childCols = createChildColumns(item);
      colConfig.children = childCols;
    }
    list.push(colConfig);
  });
  list.unshift({
    colKey: 'row-select',
    type: props.multiple ? 'multiple' : 'single',
    width: 32,
    resizable: false
  });
  return list;
};
// 弹窗表格
const { tProps, setTProps, tPropsEvent, setLoadListParams, loadTList } = useFhTable(layoutService.getObjectListPage.bind(layoutService));

// 表格的属性和事件
const tableObj = reactive({
  attr: {
    rowSelection: props.multiple ? { type: 'checkbox', showCheckedAll: true } : { type: 'radio' }
  },
  ev: {}
});
// 设置属性
setTProps({
  ...tableObj.attr
});

const ids = ref([]);

const openDialog = async (isOpen = true) => {
  if (props.disabled) return;
  if (props.taskItem.status == 4) {
    Message.success('任务已完成');
    return;
  }
  if (props.taskItem.entityStatus == 2) {
    Message.error(props.taskItem.entityStatusMessage);
    return;
  }
  if (props.id) ids.value = props.id;
  console.log('默认选中值', ids.value);
  filterVisible.value = false;
  try {
    popColumns.value = [];
    tableLoading.value = true;
    await getAssociationRadioFields(true);
    tableLoading.value = false;
    visible.value = isOpen;
    formatPopColumns.value = getColumns(popColumns.value);
    const params = {
      scope: '0',
      entity: data?.entity,
      page: data.page,
      pageSize: data.pageSize
    };
    setLoadListParams(params);
    await loadTList(1);
  } catch (e) {
    tableLoading.value = false;
    visible.value = false;
  }
};

// 表格选择
const xlTableSelect = (v) => {
  ids.value = v;
};
// 弹窗确定
const handleOk = async (done) => {
  console.log(240, done);
  if (!ids.value?.length) {
    Message.warning('至少选择一项数据');
    return false;
  }
  selectVal.value = props.multiple ? ids.value : ids.value?.[0];
  let item = tProps.value.data.filter((el) => ids.value.indexOf(el.id) > -1);
  item = item.map((el) => {
    el[`_name`] = el[mainField.value];
    el['value'] = el?.id;
    el['label'] = el[mainField.value];
    selectOption.value = el[mainField.value];
    return el;
  });
  visible.value = false;
  emits('changeCb', item, mainField.value);
  emits('update:selectedItem', props.multiple ? item : item?.[0]);
};

// 加载
const buttonText = ref({});
onMounted(async () => {
  data.entity = Number(props.entity);

  nextTick(() => {
    getAddRule();
    buttonText.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, data.entity);
  });
  await getObjectName();
  // await getAssociationRadioFields();
  // await getEntityList();
});
const addEditRef = ref();
const openLyForm = () => {
  const params = { id: '', type: 30, viewId: -1, entity: data?.entity, copy: 0 };
  addEditRef.value?.open(params);
};
const roleName = ref('');
const getAddRule = () => {
  let _roleName = '';
  if (data?.entity == '1') {
    _roleName = 'clue';
  } else if (data?.entity == '101') {
    _roleName = 'cluePool';
  } else if (data?.entity == '2') {
    _roleName = 'customer';
  } else if (data?.entity == '3') {
    _roleName = 'businessOpportunity';
  } else if (data?.entity == '4') {
    _roleName = 'product';
  } else if (data?.entity == '6') {
    _roleName = 'priceSheet';
  } else if (data?.entity == '8') {
    _roleName = 'contract';
  } else if (data?.entity == '10') {
    _roleName = 'saleOrder';
  } else if (data?.entity == '12') {
    _roleName = 'afterSale';
  } else if (data?.entity == '13') {
    _roleName = 'returnOrder';
  } else if (data?.entity == '16') {
    _roleName = 'dynamicRecord';
  } else if (data?.entity >= '200') {
    //内置路由
    _roleName = data?.entity;
  }

  roleName.value = `${_roleName}:add`;
};
const objectName = ref('');
const getObjectName = async () => {
  try {
    const res = await setService.getSysObjEnumList({ entityType: props.entity });
    if (!res.error) {
      objectName.value = res.result?.entityName;
    }
  } catch (e) {
    console.log(e);
  }
};
const clearHandle = () => {
  selectVal.value = props.multiple ? [] : '';
};
watchEffect(() => {
  selectVal.value = props.multiple && props.modelValue && props.modelValue !== '' ? props.modelValue?.map((el) => (el != '' && Number(el)) || []) : Number(props.modelValue) || '';
});
/******** 搜索开始 **********/

const filterVisible = ref(false);
const toggleVisible = () => {
  filterVisible.value = !filterVisible.value;
};
const filterText = ref(t('筛选'));

const getConditions = async () => {
  filterConditions.value.children = await customFieldConditionRef.value.getAllConditions(false);
  const params = {
    scope: '0',
    entity: data?.entity,
    page: data.page,
    pageSize: data.pageSize,
    conditions: filterConditions.value.children
  };
  setLoadListParams(params);
  // await loadTList(1);
  // addSettingField(record);
};

const searchSubmit = async () => {
  filterText.value = filterConditions.value?.children?.length ? t('筛选') + '+' + filterConditions.value.children.length : t('筛选');
  await loadTList(1);
  toggleVisible();
};

//清空所有
const clearAllCondition = () => {
  filterConditions.value = {};
  filterConditions.value.children = [];
};

// const addSettingField = async (record) => {
//   const arr = JSON.parse(JSON.stringify(record));
//   let _number = 0;
//   const _condition = [];
//   arr.forEach((item) => {
//     const _item = JSON.parse(JSON.stringify(item));
//     _item.children = [];
//     item.children.forEach((child) => {
//       if (child?.operation == 'null' || child?.operation == 'not_null' || child?.value || child?.value === 0) {
//         if (!Array.isArray(child?.value) || child?.value?.length > 0) {
//           //兼容空数组判定为true
//           _number++;
//           _item.children.push(child);
//         }
//       }
//       console.log('child', child);
//     });
//     if (_item?.children?.length > 0) {
//       _condition.push(_item);
//     }
//   });
//   if (_number == 0) {
//     filterText.value = t('筛选');
//   } else {
//     filterText.value = t('筛选') + '+' + _number;
//   }

//   const params = {
//     scope: '0',
//     entity: data?.entity,
//     page: data.page,
//     pageSize: data.pageSize,
//     conditions: _condition
//   };
//   setLoadListParams(params);
//   await loadTList(1);
// };

/******** 搜索结束 **********/
</script>

<style scoped lang="less">
@import './xl-entity-data-list.less';
</style>
